module.exports = __webpack_public_path__ + "img/delete.599fcb70.svg";